var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"slide-row"},[_c('div',{staticClass:"icon"},[_c(_vm.icon,{tag:"component",attrs:{"size":14}})],1),_c('div',{staticClass:"text"},[_vm._v(" "+_vm._s(_vm.text)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }